import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { DISCLAIMER_CONVERTER_TOKEN, DisclaimerConverter } from './disclaimer.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        disclaimerFeature: {
          module: () => import('./disclaimer.module').then((m) => m.DisclaimerModule),
          cmsComponents: ['disclaimer'],
        },
      }
    }),
    {
      provide: DISCLAIMER_CONVERTER_TOKEN,
      useExisting: DisclaimerConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        disclaimer: DISCLAIMER_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class DisclaimerFeatureModule {}
